/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'CATEDRAL DE VALENCIA',
        preferVisitRead: 'Prefiero leer',
        preferVisitListten: 'Prefiero escuchar',
        downloadAudio: '(Downloading)',
        download:'Descargando',
        errorDownload: 'Error en la descarga.',
        cancelDownload: 'Has cancelado la descarga.',
        initDownload: 'Por favor, espere mientras se descargan los audios.',
        endDownload: 'Audios descargados. ¡Disfrute de la visita!',
        retry: 'Reintentar',
        noConnection: 'No tienes conexión a internet',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Bienvenida',
                author: 'Por favor, use auriculares',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Capilla de San Sebastián',
                author: 'Pie de la nave',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Capilla de San Pedro Apóstol',
                author: 'Nave lateral derecha',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Capilla de San Francisco de Borja',
                author: 'Nave lateral derecha',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'Ventana en esviaje',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Altar Mayor',
                author: 'Capilla Mayor',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Ángeles músicos',
                author: 'Capilla Mayor',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Cimborrio',
                author: 'Crucero',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Puerta de la Almoina',
                author: 'Brazo derecho del crucero',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Girola + Órgano',
                author: 'Girola',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'La Resurrección',
                author: 'Capillas de la girola',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Cristo de la Buena Muerte',
                author: 'Capillas de la girola',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Virgen de la Cadira + San Jaime',
                author: 'Capillas de la girola',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'S. Dionisio y Sta. Margarita',
                author: 'Capillas de la girola',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Puerta de los Apóstoles',
                author: 'Brazo izquierdo del crucero',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Continuación de la visita',
                author: 'Nave lateral izquierda',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Custodia',
                author: 'Museo: Planta Baja',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Mal ladrón + Adoración',
                author: 'Museo: Planta Baja',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Maquetas',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apóstoles ',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'Duda de Sto. Tomás + Dormición',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Relicario',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Improperios',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Pasillo + Arte barroco',
                author: 'Museo: Segunda Planta',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Excavación arqueológica',
                author: 'Museo: Subterráneo',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Libros de coro + Última Cena',
                author: 'Museo: Planta Baja',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'El Santo Cáliz',
                author: 'Capilla del Santo Cáliz',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Capilla del Santo Cáliz',
                author: 'Capilla del Santo Cáliz',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'El Micalet ',
                author: 'Pie de la nave',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Créditos',
                isCredits:true,
                author: '',
                description: 'Trama Media para la Catedral de Valencia.<br><br>© Catedral de Valencia.<br><br>Todos los derechos reservados.<br><br>',
                audio: '',
                idCreditImage: 30,
            },

        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/castellano.js